import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import StyledWrapper, { getStyledWrapper } from "@insite/client-framework/Common/StyledWrapper";
import { useShellContext } from "@insite/client-framework/Components/IsInShell";
import siteMessage from "@insite/client-framework/SiteMessage";
import { useGetLink } from "@insite/client-framework/Store/Links/LinksSelectors";
import updateQuantity from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/UpdateQuantity";
import translate from "@insite/client-framework/Translate";
import { LinkFieldValue } from "@insite/client-framework/Types/FieldDefinition";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import Checkbox, { CheckboxPresentationProps, CheckboxProps } from "@insite/mobius/Checkbox";
import CheckboxGroup, { CheckboxGroupComponentProps } from "@insite/mobius/CheckboxGroup";
import Clickable, { ClickablePresentationProps } from "@insite/mobius/Clickable";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import { LazyImageProps } from "@insite/mobius/LazyImage";
import LoadingSpinner, { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner/LoadingSpinner";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import TextField, { TextFieldPresentationProps, TextFieldProps } from "@insite/mobius/TextField";
import ToasterContext from "@insite/mobius/Toast/ToasterContext";
import Typography, { TypographyPresentationProps, TypographyProps } from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { FieldSetGroupPresentationProps } from "@insite/mobius/utilities/fieldSetProps";
import { useHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import cancelSubscriptionForm from "@TKCCP/Handler/TkccpCancelSubscriptionHandler";
import getSubscribedProductData from "@TKCCP/Handler/TkccpGetMySuscribedProducts";
import loadSubscriptionProductData from "@TKCCP/Handler/TkccpSubscriptionProductHandler";
import CustomApplicationState from "@TKCCP/Store/CustomHandlerCreator/CustomApplicationState";
import parse from "html-react-parser";
import React, { useContext, useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const enum fields {
    label = "label",
    link = "link",
    variant = "variant",
    noProducts = "noProducts",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.variant]: "primary" | "secondary" | "tertiary";
        [fields.label]: string;
        [fields.link]: LinkFieldValue;
        [fields.noProducts]: string;
    };
}
interface OwnProps {
    productInfo: ProductInfo;
}

const mapStateToProps = (state: CustomApplicationState) => {
    return {
        SubscribedProducts: state.tKCCPData.SubscriptionProductStore?.setSubscribedProduct,
        CustomerId: state.context.session.billToId || "",
        UserProfileId: state.context.session.userProfileId || "",
        isPunchOutSubFlag: state.context.session?.userRoles?.split(", ").some(val => {
            return val === "PunchOut";
        }),
    };
};

export interface SubscribedListProductSytles {
    title: TypographyProps;
    editSubsText: TypographyProps;
    checkboxGroup?: FieldSetGroupPresentationProps<CheckboxGroupComponentProps>;
    checkbox?: CheckboxPresentationProps;
    subscriptionMainContainer?: GridContainerProps;
    subscriptionGirdItem?: GridItemProps;
    subscriptionSubGridItem?: GridItemProps;
    selectedCheckbox?: CheckboxPresentationProps;
    image?: LazyImageProps;
    StartEndWrapper?: InjectableCss;
    titleWrapper?: InjectableCss;
    priceLabelText?: TypographyPresentationProps;
    productLabelText?: ClickablePresentationProps;
    dateText?: TypographyPresentationProps;
    amountLabelText?: TypographyPresentationProps;
    nameWrapper?: InjectableCss;
    yesnoWrapper?: InjectableCss;
    mainWrapper?: InjectableCss;
    quantityWrapper?: InjectableCss;
    centeringWrapper?: InjectableCss;
    spinner?: LoadingSpinnerProps;
    qunaityField?: TextFieldProps;
    cancelButton?: ButtonPresentationProps;
    cancelButtonWrapper?: InjectableCss;
    createListModal?: ModalPresentationProps;
}

export const SubscribedListProductSytles: SubscribedListProductSytles = {
    title: {
        variant: "h1",
        css: css`
            margin-bottom: 0rem;
        `,
    },
    editSubsText:{
        css: css`
        margin: 0rem;
        margin-top: 5px;
        margin-bottom: 30px;
        font-size: 15px;
        display: inline-block;
    `,
    },
    titleWrapper: {
        css: css`
            display: flex;
            flex-direction: row;
            gap: 150px;
            margin-bottom: 0px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-direction: column;
                        align-items: baseline;
                        justify-content: unset;
                        gap: 10px;
                    `,
                    css`
                        flex-direction: column;
                        align-items: baseline;
                        justify-content: unset;
                        gap: 10px;
                    `,
                    css`
                        flex-direction: column;
                        align-items: baseline;
                        justify-content: unset;
                        gap: 10px;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    checkboxGroup: {
        css: css`
            align-items: flex-start;
            height: 100%;
            justify-content: center;
        `,
    },
    subscriptionGirdItem: {
        css: css`
            flex-direction: column;
            width: 100%;
            max-width: 100%;
            flex-basis: auto;
        `,
    },
    subscriptionSubGridItem: {
        css: css`
            border-top: 1px solid #cecece;
            width: 100%;
            max-width: 100%;
            flex-basis: auto;
            padding: 10px 0px;
            margin: 10px 0px !important;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding-bottom: 0px;
                    `,
                    css`
                        padding-bottom: 0px;
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    StartEndWrapper: {
        css: css`
            display: flex;
            flex-direction: row;
            gap: 15px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        gap: 10px;
                    `,
                    css`
                        gap: 10px;
                    `,
                    css`
                        gap: 10px;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    nameWrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            /* margin-left: 30px; */
            /* width: 400px; */
        `,
    },
    mainWrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            border-top: 1px solid grey;
            padding: 15px;
            /* margin-left: 30px; */
        `,
    },
    productLabelText: {
        css: css`
            font-weight: bold;
            color: #000;
            font-size: x-large;
        `,
    },

    centeringWrapper: {
        css: css`
            width: 100%;
            height: 300px;
            display: flex;
            align-items: center;
            border-top: 2px SOLID BLACK;
        `,
    },
    yesnoWrapper: {
        css: css`
            width: 100%;
            display: flex;
            align-items: center;
            margin: auto;
            gap: 50px;
            margin-top: 40px;
            justify-content: center;
        `,
    },
    spinner: {
        css: css`
            margin: auto;
        `,
    },
    dateText: {
        css: css`
            margin-left: 30px;
            display: flex;
            flex-direction: row;
            gap: 5px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin-left: 25px;
                        gap: 0px;
                        font-size: 13px;
                    `,
                    css`
                        margin-left: 25px;
                        gap: 3px;
                    `,
                    css`
                        margin-left: 25px;
                        gap: 3px;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    priceLabelText: {
        css: css`
            font-weight: bold;
            color: #7b7b7b;
        `,
    },
    amountLabelText: {
        css: css`
            color: #7b7b7b;
        `,
    },

    quantityWrapper: {
        css: css`
            margin-left: 80px;
        `,
    },

    qunaityField: {
        css: css`
            width: 40px !important;
        `,
    },

    cancelButton: {
        css: css`
            margin-top: 0px;
        `,
    },
    cancelButtonWrapper: {
        css: css`
            /* margin-bottom: 10px;
            margin-top: 15px; */
            display: flex;
            justify-content: end;
            gap: 20px;
            margin-top: 10px;
        `,
    },
    createListModal: {
        closeButtonProps: {
            shape: "rounded",
            buttonType: "solid",
            size: 36,
        },
        closeButtonIconProps: {
            src: "X",
            size: 24,
            color: "#525252",
            css: css`
                svg {
                    color: #525252 !important;
                }
            `,
        },

        cssOverrides: {
            modalBody: css`
                padding: 0px;
                width: 680px;
            `,
            modalTitle: css`
                color: #000;
            `,
            modalContent: css``,
            titleButton: css``,
        },
    },
};

const styles = SubscribedListProductSytles;

const mapDispatchToProps = {
    updateQuantity,
    getSubscribedProductData,
    loadSubscriptionProductData,
    cancelSubscriptionForm,
};

type Props = OwnProps & WidgetProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

const SubscribedListProduct = ({
    productInfo,
    CustomerId,
    UserProfileId,
    getSubscribedProductData,
    SubscribedProducts,
    loadSubscriptionProductData,
    cancelSubscriptionForm,
    isPunchOutSubFlag,
    fields,
}: Props) => {
    if (isPunchOutSubFlag) {
        return null;
    }

    const [selectedProduct, setSelectedProduct] = useState(false);
    const [subscribedProductList, setSubscribedProductList] = useState(SubscribedProducts);
    const [cancelSubscriptionList, setCancelSubscriptionList] = useState<string[]>([]);
    const [createListModalIsOpen, newcreateListModalIsOpen] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const toasterContext = useContext(ToasterContext);
    const link = useGetLink(fields.link);
    const history = useHistory();
    const { isInShell } = useShellContext();
    const subscriptionEditMessage = siteMessage("Subscription_editpageMsg");

    // Error
    const SelectedProductErrorMessage = siteMessage("Select any one Coffee");
    const [selectedProductError, setSelectedProductError] = React.useState(SelectedProductErrorMessage);

    useEffect(() => {
        getSubscribedProductData({
            CustomerId,
            UserProfileId,
        });
    }, []);

    useEffect(() => {
        if (SubscribedProducts.length > 0) {
            const setAllCheckBoxFalse = SubscribedProducts.map(product => {
                const products = { ...product };
                products.isActive = false;
                return products;
            });
            setSubscribedProductList(setAllCheckBoxFalse);
        }
    }, [SubscribedProducts]);

    const modalCloseHandler = () => {
        newcreateListModalIsOpen(false);
    };
    const buttonClickHandler = () => {
        if (!validateNextEnabled()) {
            toasterContext.addToast({
                body: translate("Select subscription you want to cancel"),
                messageType: "danger",
            });
            return;
        }

        newcreateListModalIsOpen(true);
    };
    React.useEffect(() => {
        const timer = setTimeout(() => {
            setIsOpen(true);
        }, 1000);
    }, []);

    const validateNextEnabled = () => {
        return !selectedProductError;
    };
    // checkbox

    const validateSelectedCheckboxType = (selectedProduct: any) => {
        const selectedProductError =
            !selectedProduct || selectedProduct?.length <= 0 ? (SelectedProductErrorMessage as string) : "";
        setSelectedProductError(selectedProductError);
        return !selectedProductError;
    };

    const selectChangeHandler = (value: boolean, id?: string) => {
        validateSelectedCheckboxType(value);
        let cancelSubscriptionIdList = [];
        const filterData = subscribedProductList.map(product => {
            const products = { ...product };
            if (products.id === id) {
                products.isActive = value;
            }
            return products;
        });
        setSubscribedProductList(filterData);
        cancelSubscriptionIdList = [...cancelSubscriptionList];
        if (!value) {
            cancelSubscriptionIdList = cancelSubscriptionIdList.filter(cancelId => {
                return cancelId !== id;
            });
        } else {
            cancelSubscriptionIdList = [...cancelSubscriptionList, id];
        }
        cancelSubscriptionIdList = cancelSubscriptionIdList.filter(option => option !== undefined) as string[];
        setCancelSubscriptionList(cancelSubscriptionIdList);
    };

    const formatDate = (dateString: string | number | Date | undefined) => {
        if (!dateString) {
            return "";
        } // If dateString is undefined, return an empty string
        const date = new Date(dateString);
        // console.log(date.toISOString().split("T")[0], dateString);

        // Extract year, month, and day
        const year = date.getFullYear();
        const month = (`0${  date.getMonth() + 1}`).slice(-2); // Adding leading zero if needed
        const day = (`0${  date.getDate()}`).slice(-2); // Adding leading zero if needed

        // Format the date in "YYYY-MM-DD" format
        const formattedDate = `${year  }-${  month  }-${  day}`;

        return formattedDate; // Extracting date part
    };

    const getSpecificSubscribedProducts = (id: string) => {
        loadSubscriptionProductData({
            SubscriptionId: id,
            customerBillToId: CustomerId,
        });
    };

    const cancelSubscriptionhandler = () => {
        cancelSubscriptionForm({
            SubscriptionIdList: cancelSubscriptionList,
        });
        toasterContext.addToast({ body: translate("Subscription Cancelled "), messageType: "success" });

        window.location.reload();
    };

    const onClick = () => {
        if (!link.url) {
            return;
        }

        if (link.url.startsWith("http")) {
            if (isInShell) {
                return;
            }

            window.location.href = link.url;
        } else {
            history.push(link.url);
        }
    };

    const isCancelDisabled =
    !subscribedProductList?.length || cancelSubscriptionList.length === 0;

    return (
        <StyledWrapper>
            <StyledWrapper {...styles.titleWrapper}>
                <Typography {...styles.title}>{translate("My Subscription")}</Typography>
                <StyledWrapper {...styles.cancelButtonWrapper}>
                    <StyledWrapper>
                        <Clickable onClick={buttonClickHandler}>
                            <Button {...styles.cancelButton} disabled={isCancelDisabled} className="button">
                                {translate("Cancel Subscription ")}
                            </Button>
                        </Clickable>
                        {isOpen && (
                            <Modal
                                {...styles.createListModal}
                                isOpen={createListModalIsOpen}
                                handleClose={modalCloseHandler}
                                headline={translate("Cancel subscription")}
                            >
                                <StyledWrapper {...styles.productLabelText}>
                                    {translate("Are you sure you want to cancel the subscription ?")}
                                </StyledWrapper>
                                <StyledWrapper {...styles.yesnoWrapper}>
                                    <Button {...styles.cancelButton} onClick={cancelSubscriptionhandler}>
                                        {translate("YES")}
                                    </Button>
                                    <Button {...styles.cancelButton} onClick={modalCloseHandler}>
                                        {translate("NO")}
                                    </Button>
                                </StyledWrapper>
                            </Modal>
                        )}
                    </StyledWrapper>
                    <StyledWrapper>
                        <Button {...styles.cancelButton} variant={fields.variant} onClick={onClick} className="button">
                            {fields.label}
                        </Button>
                    </StyledWrapper>
                </StyledWrapper>
            </StyledWrapper>
            <Typography {...styles.editSubsText}>{subscriptionEditMessage}</Typography>
            {subscribedProductList?.length ? (
                subscribedProductList.map((ProductsSubscribed, index) => (
                    <StyledWrapper key={" "} {...styles.mainWrapper}>
                        <StyledWrapper {...styles.StartEndWrapper}>
                            <Checkbox
                                {...styles.selectedCheckbox}
                                checked={ProductsSubscribed.isActive}
                                onChange={(e, value) => selectChangeHandler(value, ProductsSubscribed.id)}
                                data-test-selector="myListDetails_selectRowCheckbox"
                            />
                            {/* <Link href="/EditSubscription/asdfa" {...styles.productLabelText}>
                                {ProductsSubscribed.name}
                            </Link> */}
                            <Clickable
                                href={`MyAccount/MySubscription/EditSubscription?id=${ProductsSubscribed.id}`}
                                {...styles.productLabelText}
                                // onClick={() => {
                                //     getSpecificSubscribedProducts(ProductsSubscribed.id);
                                // }}
                            >
                                {ProductsSubscribed.name}
                            </Clickable>
                        </StyledWrapper>
                        <StyledWrapper {...styles.dateText}>
                            <StyledWrapper>
                                {siteMessage("Start Date")} : {formatDate(ProductsSubscribed.startDate)}
                            </StyledWrapper>
                            ~
                            <StyledWrapper>
                                {ProductsSubscribed.endDate ? (
                                    <>
                                        {siteMessage("End Date")} : {formatDate(ProductsSubscribed.endDate)}
                                    </>
                                ) : (
                                    <StyledWrapper>{siteMessage("No end date available")}</StyledWrapper>
                                )}
                            </StyledWrapper>
                        </StyledWrapper>
                    </StyledWrapper>
                ))
            ) : (
                <StyledWrapper {...styles.centeringWrapper}>
                    <StyledWrapper {...styles.spinner}>{parse(fields.noProducts, parserOptions)}</StyledWrapper>
                </StyledWrapper>
            )}
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(SubscribedListProduct),
    definition: {
        group: "Basic",
        displayName: "Subscribed Product",
        fieldDefinitions: [
            {
                name: fields.variant,
                displayName: "Button Variant",
                editorTemplate: "DropDownField",
                options: [
                    { displayName: "Primary", value: "primary" },
                    { displayName: "Secondary", value: "secondary" },
                    { displayName: "Tertiary", value: "tertiary" },
                ],
                defaultValue: "primary",
                fieldType: "General",
            },
            {
                name: fields.label,
                displayName: "Button Label",
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "Translatable",
            },
            {
                name: fields.link,
                displayName: "Button Link",
                editorTemplate: "LinkField",
                defaultValue: {
                    value: "",
                    type: "Page",
                },
                fieldType: "General",
            },

            {
                name: fields.noProducts,
                displayName: "No Products Text",
                editorTemplate: "RichTextField",
                defaultValue: "",
                fieldType: "Translatable",
            },
        ],
    },
};

export default widgetModule;
